










































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentDescontosPrestador extends Vue {
  get modalDescontosPrestador() { return this.getFinanceiroStore.modal.descontosPrestador }
  set modalDescontosPrestador(value: boolean) { this.getFinanceiroStore.setModal({ name: 'descontosPrestador', value }) }

  get descontosPrestadorHeader() {
    return this.getFinanceiroStore.descontosPrestadorHeader
  }

  get descontosPrestador() {
    return this.getFinanceiroStore.descontosPrestador
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
